import { biggerOrTo } from '../../render-helper';

export default [
  {
    header: 'Time',
    render: 'time',
  },
  {
    header: 'Influencer',
    render: 'user_name',
  },
  {
    header: 'Value',
    render: 'value',
    numFmt: '#,##',
    renderHelper: [biggerOrTo(0, '')],
  },
];
